// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Id1
 */
export interface Id1 {}

/**
 * Check if a given object implements the Id1 interface.
 */
export function instanceOfId1(value: object): value is Id1 {
  return true;
}

export function Id1FromJSON(json: any): Id1 {
  return Id1FromJSONTyped(json, false);
}

export function Id1FromJSONTyped(json: any, ignoreDiscriminator: boolean): Id1 {
  return json;
}

export function Id1ToJSON(json: any): Id1 {
  return Id1ToJSONTyped(json, false);
}

export function Id1ToJSONTyped(value?: Id1 | null, ignoreDiscriminator: boolean = false): any {
  return value;
}
